import { css } from '@emotion/css';

export const styLeftHalf = color => css`
  float: left;
  width: 5px;
  height: 10px;
  line-height: 10px;
  color: white;
  text-align: center;
  background: ${color};
  border-radius: 10px 0 0 10px;
`;

export const styRightHalf = color => css`
  float: left;
  width: 5px;
  height: 10px;
  line-height: 10px;
  color: white;
  text-align: center;
  background: ${color};
  margin-right: 8px;
  border-radius: 0 10px 10px 0;
`;

export const styContainer = css`
  display: flex;
  align-items: center;
`;
